import styled from "styled-components";

export const Button = styled.button`
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 8px;
  height: 48px;
  padding: 0 24px;
  color: #fff;
  background-color: rgb(202, 160, 66);
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.7px;
  text-transform: uppercase;
  border-radius: 24px;
  text-decoration: none;
  transition: box-shadow 150ms ease;
  white-space: nowrap;

  &:disabled {
    background-color: #d6c8ac;
    cursor: default;
  }

  &:focus {
    outline: none;
    box-shadow: 0px 0px 0px 3px rgba(255, 255, 255, 0.2);
  }

  @media (max-width: 1023px) {
    width: 100%;
  }

  @media (min-width: 1024px) {
    width: fit-content;
  }

  span {
    margin-top: 1px;
  }
`;
